import { Button, Group } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React, { useEffect, useState } from 'react';
import { Check, X } from 'tabler-icons-react';
import { OpenComponent } from '../../../enums/misc.enum';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { IPaginationMeta } from '../../../type/admin.types';
import { ErrorResponse } from '../../../type/error-response.types';
import { BasicAccount } from '../../../type/retrieve-account.types';
import DisabledModal from '../../admin-entities/admin-entity-manager/components/disabled-modal.component';

interface Props {
  isChecked: number[];
  userData: BasicAccount[] | undefined;
  createRequest: (
    page: number,
    clearIsChecked: boolean,
    username?: string
  ) => Promise<void>;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  paginationData: IPaginationMeta;
  firstUserId: number | undefined;
}

function UpdateEnableDisableButtons(props: Props) {
  const {
    isChecked,
    userData,
    createRequest,
    setComponentManager,
    paginationData,
    firstUserId
  } = props;
  const [disableUpdate, setDisableUpdate] = useState(true);
  const [disableEnable, setDisableEnable] = useState(true);
  const [disableDisable, setDisableDisable] = useState(true);
  const [loadingEnable, setLoadingEnable] = useState(false);
  const [loadingDisable, setLoadingDisable] = useState(false);
  const [isDisabledModalOpen, setisDisabledModalOpen] = useState(false);

  const getEntityName = (): string => {
    let name = 'item';

    if (userData) {
      if (isChecked?.length > 1) {
        name = 'account';
      } else if (isChecked?.length === 1) {
        const selectedMerchant = userData.find(
          (user) => user.accountId === isChecked[0]
        );
        name = `${selectedMerchant?.user.firstName} ${
          selectedMerchant?.user.middleName
        } ${selectedMerchant?.user.lastName || 'account'}`;
      }
    }

    return name;
  };

  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    setDisableUpdate(false);
    setDisableEnable(false);
    setDisableDisable(false);

    if (isChecked.length === 0) {
      setDisableUpdate(true);
      setDisableEnable(true);
      setDisableDisable(true);
    } else if (isChecked.length > 1) {
      setDisableUpdate(true);
    }
    if (isChecked.length > 0) {
      userData?.forEach((user) => {
        if (isChecked.includes(user.accountId)) {
          if (firstUserId && isChecked.includes(firstUserId)) {
            setDisableEnable(true);
            setDisableDisable(true);
          }
          if (user.isActive) {
            setDisableEnable(true);
          } else {
            setDisableUpdate(true);
            setDisableDisable(true);
          }
        }
      });
    }
  }, [isChecked, userData]);

  const cleanTable = () => {
    createRequest(paginationData.currentPage, false);
  };

  const handleEnable = async () => {
    setLoadingEnable(true);
    try {
      await axiosPrivate.post('/web/accounts/enable', {
        accountIds: isChecked
      });
      showNotification({
        id: 'successfully-enabled-accounts',
        message: 'Successfully enabled selected account/s',
        icon: <Check size={16} />,
        color: 'teal',
        autoClose: 6000
      });

      cleanTable();
    } catch (err: any) {
      const error: ErrorResponse = err.response?.data;
      showNotification({
        id: 'failed-to-enable-account',
        message: error.error || 'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000
      });
    } finally {
      setLoadingEnable(false);
    }
  };

  const handleDisable = async (disabledReason: string) => {
    setLoadingDisable(true);
    try {
      await axiosPrivate.post('/web/accounts/disable', {
        accountIds: isChecked,
        disabledReason
      });
      showNotification({
        id: 'successfully-disabled-accounts',
        message: 'Successfully disabled selected account/s',
        icon: <Check size={16} />,
        color: 'teal',
        autoClose: 6000
      });
      cleanTable();
    } catch (err: any) {
      const error: ErrorResponse = err.response?.data;
      showNotification({
        id: 'failed-to-disable-account',
        message: error.error || 'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000
      });
    } finally {
      setLoadingDisable(false);
    }
  };

  return (
    <>
      <DisabledModal
        handleClose={() => setisDisabledModalOpen(false)}
        isDisabledModalOpen={isDisabledModalOpen}
        disableFunction={handleDisable}
        disableTitle={'Onboarding'}
        disableName={getEntityName()}
      />
      <Group>
        <Button
          disabled={disableUpdate}
          onClick={() => setComponentManager(OpenComponent.UPDATE_USER)}
        >
          UPDATE
        </Button>
        <Button
          disabled={disableEnable}
          onClick={handleEnable}
          loading={loadingEnable}
        >
          ENABLE
        </Button>
        <Button
          color="red"
          disabled={disableDisable}
          onClick={() => setisDisabledModalOpen(true)}
          loading={loadingDisable}
        >
          DISABLE
        </Button>
      </Group>
    </>
  );
}

export default UpdateEnableDisableButtons;
